import Vue from 'vue'
import VueRouter from 'vue-router'
import pages from './pages'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
Vue.use(VueRouter)
const router = new VueRouter({
  routes: [
    ...pages,

  ]
})
router.beforeEach((to, from, next) => {
  // 检查本地存储中是否存在 'user-token'
  const userToken = localStorage.getItem('Authorization');

  if (to.path !== '/login' && to.path !== '/indexno' && to.path !== '/yonghuxieyi' && !userToken && to.path !== '/nocounseling') {
    // 如果用户尝试访问非登录页面，且本地存储中不存在 'user-token'，则弹出选择框
    Vue.prototype.$msgbox({
      title: '请先登录',
      message: '您是家长还是教师？',
      showCancelButton: true,
      confirmButtonText: '我是教师',
      cancelButtonText: '我是家长',
    }).then(action => {
      if (action === 'confirm') {
        // 如果用户选择了 '我是教师'，则导航到教师登录页面
        next('login?id=0');
      }
    }).catch(() => {
      // 如果用户选择了 '我是家长'，则导航到家长登录页面
      next('login?id=1');
    });
  } else {
    // 否则，允许路由导航
    next();
  }
});
export default router 


// WEBPACK FOOTER //
// ./src/vue-router/index.js